import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isAdminSubdomain } from '@/utils/subdomainDetection';

/**
 * SubdomainHandler component
 * Automatically redirects to admin routes when accessing admin subdomain
 */
export const SubdomainHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If we're on admin subdomain but not on admin route, redirect to admin
    if (isAdminSubdomain() && !location.pathname.startsWith('/admin')) {
      // Only redirect from root path to avoid breaking other functionality
      if (location.pathname === '/') {
        navigate('/admin', { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  return <>{children}</>;
};